import { useMemo } from 'react';
import { useCmsCollection } from '../hooks/useCms';
import { cleanPath, slugOf } from '../lib/content';
import { SiteContext } from './siteContext';

export function SiteProvider({ children }) {
  const pageResult = useCmsCollection('site_pages');
  const navResult = useCmsCollection('navigation_items');
  const settingsResult = useCmsCollection('site_settings');

  const value = useMemo(() => {
    const pages = pageResult.items;
    return {
      pages,
      pagesLoading: pageResult.loading,
      pagesError: pageResult.error,
      retryPages: pageResult.retry,
      navigation: navResult.items,
      settings: settingsResult.items[0] ?? null,
      pageById: (id) => pages.find((page) => slugOf(page) === id),
      pageByPath: (path) => pages.find((page) => cleanPath(page.path) === cleanPath(path)),
      pathFor: (id) => pages.find((page) => slugOf(page) === id)?.path ?? '',
    };
  }, [pageResult.items, pageResult.loading, pageResult.error, pageResult.retry, navResult.items, settingsResult.items]);

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}
